import {
  ChartBarSquareIcon,
  FireIcon,
  GiftIcon,
  RocketLaunchIcon,
  TicketIcon,
  TrophyIcon,
  SparklesIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import CasinoPromoCard from "../components/CasinoPromoCard";
import { classicGames } from "../lib/classicGames";
import T20BettingPage from "./T20BettingPage";

const winStrip = [
  { name: "Crash", amount: "126.6k USDT", image: "/img/crash.png" },
  { name: "Limbo", amount: "98.2k USDT", image: "/img/win-bt.jpeg" },
  { name: "Lucky Wheel", amount: "81.4k USDT", image: "/img/spin-win.jpeg" },
  { name: "Dice Duel", amount: "64.8k USDT", image: "/img/coin.png" },
  { name: "Coin Toss", amount: "52.1k USDT", image: "/img/bonus.jpeg" },
  { name: "Mini Keno", amount: "47.7k USDT", image: "/img/spin-win.jpeg" },
  { name: "Crash", amount: "39.5k USDT", image: "/img/crash.png" },
  { name: "Limbo", amount: "31.8k USDT", image: "/img/win-bt.jpeg" },
  { name: "Lucky Wheel", amount: "28.4k USDT", image: "/img/spin-win.jpeg" },
  { name: "Dice Duel", amount: "19.1k USDT", image: "/img/coin.png" },
];

const categoryTiles = [
  {
    title: "Casino",
    copy: "Dive into originals, live casino, and slots.",
    icon: FireIcon,
    image: "/img/casino.png",
    tone: "from-[#1d2f2b] to-[#223338]",
    to: "/casino",
    wide: true,
  },
  {
    title: "Sports",
    copy: "Bet on Football, Cricket, NFL, eSports and more.",
    icon: TrophyIcon,
    image: "/img/bonus.jpeg",
    tone: "from-[#3b2742] to-[#312a39]",
    to: "/sports",
    wide: true,
  },
  {
    title: "Lottery",
    icon: TicketIcon,
    image: "/img/win-bt.jpeg",
    tone: "from-[#3d3520] to-[#303427]",
    to: "/agents",
  },
  {
    title: "Racing",
    icon: RocketLaunchIcon,
    image: "/img/crash.png",
    tone: "from-[#27312c] to-[#2d3632]",
    to: "/crash",
  },
  {
    title: "UpDown",
    icon: ChartBarSquareIcon,
    image: "/img/spin-win.jpeg",
    tone: "from-[#2f3d22] to-[#2d3927]",
    to: "/sports/t20-betting",
  },
  {
    title: "Bingo",
    icon: SparklesIcon,
    image: "/img/bonus.jpeg",
    tone: "from-[#382844] to-[#31283a]",
    to: "/casino",
  },
];

const originals = [
  {
    title: "Crash",
    image: "/img/crash.png",
    to: "/crash",
    amount: "126.6k USDT",
  },
  {
    title: "Limbo",
    image: "/img/win-bt.jpeg",
    to: "/casino/limbo",
    amount: "98.2k USDT",
  },
  {
    title: "Lucky Wheel",
    image: "/img/spin-win.jpeg",
    to: "/casino/lucky-wheel",
    amount: "81.4k USDT",
  },
  {
    title: "Dice Duel",
    image: "/img/coin.png",
    to: "/casino/dice-duel",
    amount: "64.8k USDT",
  },
  {
    title: "Coin Toss",
    image: "/img/bonus.jpeg",
    to: "/casino/coin-toss",
    amount: "52.1k USDT",
  },
  {
    title: "Mini Keno",
    image: "/img/spin-win.jpeg",
    to: "/casino/keno",
    amount: "47.7k USDT",
  },
];

const classicCards = classicGames.map((game) => ({
  title: game.title,
  image: game.image,
  to: game.to,
  amount: game.amount,
}));

function TinyWinCard({ item }) {
  return (
    <button
      type="button"
      className="min-w-[86px] overflow-hidden rounded-[14px] bg-[#181d25] text-left transition hover:bg-[#202630]"
    >
      <img
        src={item.image}
        alt={item.name}
        className="h-14 w-full object-cover"
      />
      <div className="px-2 py-2">
        <div className="truncate text-[11px] font-bold text-white">
          {item.name}
        </div>
        <div className="mt-1 truncate text-[10px] font-semibold text-emerald-300">
          {item.amount}
        </div>
      </div>
    </button>
  );
}

function OriginalCard({ item, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="overflow-hidden rounded-[18px] bg-[#181d25] text-left transition hover:-translate-y-1 hover:bg-[#202630]"
    >
      <img
        src={item.image}
        alt={item.title}
        className="h-24 w-full object-cover"
      />
      <div className="px-3 py-3">
        <div className="text-sm font-black text-white">{item.title}</div>
        <div className="mt-1 text-xs font-semibold text-emerald-300">
          {item.amount}
        </div>
      </div>
    </button>
  );
}

export function CricketBettingHubPage() {
  return <T20BettingPage />;
}

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-[#171b22] pb-8 text-white md:mt-20">
      <main className="mx-auto w-full max-w-[1320px] px-3 py-4 sm:px-4 lg:px-5">
        <CasinoPromoCard ctaTo="/casino" />

        <section className="mt-4 rounded-[20px] bg-[#1d222b] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.24)]">
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              <span className="text-sm font-bold text-white">
                Recent Big Wins
              </span>
            </div>
            <div className="flex items-center gap-3 text-xs font-semibold text-slate-400">
              <span className="text-white">All</span>
              <span>Originals</span>
              <span>Slots</span>
              <span>Live Casino</span>
            </div>
          </div>
          <div className="mt-4 flex gap-2 overflow-x-auto pb-1">
            {winStrip.map((item, index) => (
              <TinyWinCard key={`${item.name}-${index}`} item={item} />
            ))}
          </div>
        </section>

        <section className="mt-4">
          <div className="grid auto-rows-[106px] gap-4 lg:grid-cols-[1.2fr_1.2fr_0.82fr_0.82fr]">
            {categoryTiles.map((tile) => {
              const Icon = tile.icon;
              return (
                <button
                  key={tile.title}
                  type="button"
                  onClick={() => navigate(tile.to)}
                  className={`relative overflow-hidden rounded-[20px] bg-gradient-to-br ${tile.tone} p-4 text-left transition hover:-translate-y-1 ${
                    tile.wide ? "row-span-2" : ""
                  }`}
                >
                  <div className="flex items-center gap-2 text-white">
                    <Icon className="h-5 w-5" />
                    <span className="text-2xl font-black">{tile.title}</span>
                  </div>
                  {tile.copy ? (
                    <p className="mt-3 max-w-[220px] text-sm leading-7 text-slate-200">
                      {tile.copy}
                    </p>
                  ) : null}
                  <img
                    src={tile.image}
                    alt={tile.title}
                    className={`absolute bottom-2 right-2 object-cover opacity-95 ${
                      tile.wide ? "h-28 w-28" : "h-20 w-20"
                    }`}
                  />
                </button>
              );
            })}
          </div>
        </section>

        <section className="mt-4 rounded-[20px] bg-[#1d222b] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.24)]">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-2xl font-black text-white">Originals</div>
              <div className="mt-1 text-sm text-slate-400">
                Fast access to the most played in-house games.
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button className="rounded-[12px] bg-[#2a3039] px-3 py-2 text-xs font-bold text-white">
                All
              </button>
              <button className="rounded-[12px] bg-[#2a3039] px-3 py-2 text-xs font-bold text-slate-400">
                {"<"}
              </button>
              <button className="rounded-[12px] bg-[#2a3039] px-3 py-2 text-xs font-bold text-slate-400">
                {">"}
              </button>
            </div>
          </div>
          <div className="mt-4 grid gap-3 md:grid-cols-3 xl:grid-cols-6">
            {originals.map((item) => (
              <OriginalCard
                key={item.title}
                item={item}
                onClick={() => navigate(item.to)}
              />
            ))}
          </div>
        </section>

        <section className="mt-4 rounded-[20px] bg-[#1d222b] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.24)]">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-2xl font-black text-white">Classic Games</div>
              <div className="mt-1 text-sm text-slate-400">
                Bring back XO, RPS, and Chess right from the lobby.
              </div>
            </div>
          </div>
          <div className="mt-4 grid gap-3 md:grid-cols-3">
            {classicCards.map((item) => (
              <OriginalCard
                key={item.title}
                item={item}
                onClick={() => navigate(item.to)}
              />
            ))}
          </div>
        </section>

        <section className="mt-4 rounded-[20px] bg-[#1d222b] p-4 shadow-[0_24px_70px_rgba(0,0,0,0.24)]">
          <div className="flex items-center gap-2 text-white">
            <GiftIcon className="h-5 w-5 text-emerald-300" />
            <span className="text-lg font-black">Featured Access</span>
          </div>
          <div className="mt-4 grid gap-3 md:grid-cols-3">
            {[
              {
                title: "Casino",
                copy: "Open originals and featured tables instantly.",
                to: "/casino",
              },
              {
                title: "Crash",
                copy: "Live rounds, live bets, and auto cashout controls.",
                to: "/crash",
              },
              {
                title: "Sports",
                copy: "Jump into cricket and quick-entry market panels.",
                to: "/sports",
              },
            ].map((item) => (
              <button
                key={item.title}
                type="button"
                onClick={() => navigate(item.to)}
                className="rounded-[18px] bg-[#181d25] p-4 text-left transition hover:bg-[#202630]"
              >
                <div className="text-lg font-black text-white">
                  {item.title}
                </div>
                <div className="mt-2 text-sm leading-7 text-slate-400">
                  {item.copy}
                </div>
              </button>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
